// import React, { useEffect } from "react";
// import {
//   Document,
//   Page,
//   Text,
//   View,
//   Image,
//   StyleSheet,
//   Font,
// } from "@react-pdf/renderer";
// import QRCode from "qrcode";

// // Función para generar el QR como Data URL
// const generateQR = async (url) => {
//   try {
//     return await QRCode.toDataURL(url, { margin: 1, width: 300 });
//   } catch (err) {
//     console.error("Error generando QR:", err);
//     return "";
//   }
// };

// // Estilos del PDF
// const styles = StyleSheet.create({
//   page: {
//     backgroundColor: "#fff",
//     fontFamily: "Helvetica",
//     padding: 0,
//   },
//   header: {
//     height: 60,
//     flexDirection: "row",
//     alignItems: "center",
//     justifyContent: "space-between",
//     paddingHorizontal: 20,
//   },
//   logo: {
//     width: 45,
//     height: 45,
//     objectFit: "contain",
//   },
//   titleContainer: {
//     textAlign: "center",
//     width: "100%",
//     paddingVertical: 7,
//     backgroundColor: "#E95B0C",
//   },
//   title: {
//     fontSize: 13,
//     textTransform: "uppercase",
//     color: "white",
//     fontWeight: "bold",
//   },
//   content: {
//     padding: 20,
//     textAlign: "center",
//   },
//   businessName: {
//     fontSize: 18,
//     fontWeight: "bold",
//     color: "#333",
//     marginBottom: 10,
//   },
//   exhibitorText: {
//     fontSize: 9,
//     color: "#333",
//     marginVertical: 10,
//   },
//   qrTitle: {
//     color: "#333",
//     marginVertical: 10,
//     textAlign: "center",
//     fontFamily: "Imperial Script",
//     fontSize: 25,
//   },
//   qrContainer: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   qrBorder: {
//     borderWidth: 3,
//     borderColor: "#E95B0C",
//     borderStyle: "dashed",
//   },
//   qrImage: {
//     width: 100,
//     height: 100,
//   },
//   qrCaption: {
//     fontSize: 25,
//     marginTop: 8,
//   },
//   footer: {
//     position: "absolute",
//     bottom: 25,
//     textAlign: "center",
//     width: "100%",
//     fontSize: 6,
//     color: "#777",
//   },
// });

// // 📄 Documento principal
// const StandPosterDocument = ({ fullName, businessName, qrData }) => {
//   Font.register({
//     family: "Imperial Script",
//     fonts: [
//       {
//         src: "https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/IntriqueScript.ttf",
//       },
//     ],
//   });

//   return (
//     <Document>
//       <Page size={{ width: 270, height: 390 }} style={styles.page}>
//         {/* HEADER */}
//         <View style={styles.titleContainer}>
//           <Text style={styles.title}>2a Feria de Emprendedores UAT</Text>
//         </View>
//         <View style={styles.header}>
//           <Image style={styles.logo} src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/UAT-Escudo.png" />
//           <Image
//             style={{ width: 90, height: 90, objectFit: "contain" }}
//             src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/uamvh-logotipo.png"
//           />
//         </View>

//         <Text style={styles.qrTitle}>Escanea este código para seguirnos.</Text>

//         <View style={styles.qrContainer}>
//           <View style={styles.qrBorder}>
//             <Image src={qrData} style={styles.qrImage} />
//           </View>
//           <Text style={styles.qrCaption}>{businessName}</Text>
//           <Text style={styles.exhibitorText}>Expositor: {fullName}</Text>
//         </View>

//         <Text style={styles.footer}>
//           Universidad Autónoma de Tamaulipas — Unidad Académica
//           Multidisciplinaria Valle Hermoso
//         </Text>
//       </Page>
//     </Document>
//   );
// };

// export default StandPosterDocument;

import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

// Estilos del PDF
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    fontFamily: "Helvetica",
    padding: 0,
  },
  header: {
    height: 60,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 20,
  },
  logo: {
    width: 45,
    height: 45,
    objectFit: "contain",
  },
  title: {
    fontSize: 35,
    textTransform: "uppercase",
    color: "#E95B0C",
    fontWeight: "bold",
    textAlign: "center",
    marginTop: 40,
  },
  content: {
    padding: 20,
    textAlign: "center",
  },
  businessName: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#333",
    marginBottom: 10,
  },
  exhibitorText: {
    fontSize: 9,
    color: "#333",
    marginVertical: 10,
  },
  qrTitle: {
    color: "#333",
    marginVertical: 10,
    textAlign: "center",
    fontFamily: "Imperial Script",
    fontSize: 40,
    marginTop: 35,
  },
  qrContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  qrBorder: {
    borderWidth: 3,
    borderColor: "#E95B0C",
    borderStyle: "dashed",
  },
  qrImage: {
    width: 100,
    height: 100,
  },
  qrCaption: {
    width: "100%",
    textAlign: "center",
    fontSize: 25,
    marginTop: 35,
    fontWeight: "bold",
  },
  footer: {
    position: "absolute",
    bottom: 25,
    textAlign: "center",
    width: "100%",
    fontSize: 6,
    color: "#777",
  },
});

// 📄 Documento principal
const StandPosterDocument = ({
  fullName,
  businessName,
  businessLogo,
  qrData,
}) => {
  Font.register({
    family: "Imperial Script",
    fonts: [
      {
        src: "https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/IntriqueScript.ttf",
      },
    ],
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* HEADER */}
        <Image
          style={{
            width: "101vw",
            height: "99vh",
            position: "absolute",
            opacity: 2,
            zIndex: 0,
            top: 0,
            left: 0,
          }}
          src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/background-pattern.png"
        />
        <View
          style={{
            width: "100vw",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            paddingHorizontal: 10,
          }}
        >
          <View
            style={{ width: "33.333%", height: 70, alignItems: "flex-start" }}
          >
            <Image
              style={{
                width: 80,
                height: 70,
                objectFit: "contain",
              }}
              src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/logo-uat.jpg"
            />
          </View>
          <View style={{ width: "33.333%", height: 70, alignItems: "center" }}>
            <Image
              style={{
                width: 70,
                height: 70,
                objectFit: "contain",
              }}
              src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/feria.png"
            />
          </View>
          <View
            style={{ width: "33.333%", height: 70, alignItems: "flex-end" }}
          >
            <Image
              style={{
                width: 130,
                height: 70,
                objectFit: "contain",
              }}
              src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/uamvh-logotipo.png"
            />
          </View>
        </View>
        <Text style={styles.title}>2a Feria de Emprendedores UAT</Text>

        <Text
          style={[
            styles.title,
            { fontSize: 20, color: "black", marginTop: 20 },
          ]}
        >
          Expositor
        </Text>
        <Text
          style={[
            styles.title,
            { fontSize: 20, color: "black", marginTop: 20 },
          ]}
        >
          {fullName}
        </Text>

        <Text style={styles.qrTitle}>Escanea este código para seguirnos.</Text>

        <View
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 20,
            marginTop: 20,
          }}
        >
          <View style={styles.qrContainer}>
            <View style={styles.qrBorder}>
              <Image
                src={qrData}
                style={[styles.qrImage, { width: "40vw", height: "auto" }]}
              />
            </View>
          </View>
          <Image
            style={{ width: "40vw", height: "auto", objectFit: "contain" }}
            src={businessLogo}
          />
        </View>

        <Text style={styles.qrCaption}>{businessName}</Text>

        <View
          style={{
            width: "100%",
            height: 200,
            position: "absolute",
            bottom: -90,
          }}
        >
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
              paddingHorizontal: 10,
            }}
          >
            <Image
              style={{ width: 120, height: 70, objectFit: "contain" }}
              src="https://inmchcbmnmgbtgazqkyf.supabase.co/storage/v1/object/public/PdfImages/Aniversario75.png"
            />
          </View>
          <View
            style={{
              width: "100%",
              height: 30,
              backgroundColor: "#E95B0C",
              marginTop: 10,
            }}
          ></View>
        </View>
      </Page>
    </Document>
  );
};

export default StandPosterDocument;
